import { Disclosure } from '@headlessui/react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import cx from 'classnames';

import Typography from '~/components/Typography';
import type { FAQ, FAQSection } from '~/interfaces/faq_section';

import MarkDownRender from '../Markdown/MarkDownRender';

interface Props {
  faqSection: FAQSection;
  isFirstQuestionOpen?: boolean;
}

const FAQs = ({ faqSection, isFirstQuestionOpen }: Props) => {
  return (
    <div className="w-full">
      <dl className="mt-10">
        {faqSection.faqs.map((faq: FAQ, index: number) => {
          const isLast = index === faqSection.faqs.length - 1;

          return (
            <Disclosure
              as="div"
              key={faq.question}
              className={cx('py-6', !isLast && 'border-b')}
              defaultOpen={isFirstQuestionOpen && index === 0}
              style={{
                borderColor: faqSection.faq_border_color,
              }}
            >
              {({ open }) => (
                <>
                  <dt>
                    <Disclosure.Button className="flex w-full items-start justify-between text-left text-gray-600">
                      <Typography
                        as="span"
                        size={'lg'}
                        weight="semibold"
                        fontFamily={faqSection.faq_font_family}
                        color={faqSection.faq_question_color}
                      >
                        <MarkDownRender>{faq.question}</MarkDownRender>
                      </Typography>
                      <span
                        style={{
                          color: faqSection.faq_button_color,
                        }}
                        className="ml-6 flex h-7 items-center"
                      >
                        {open ? (
                          <ChevronUpIcon className="h-5 w-5" aria-hidden="true" />
                        ) : (
                          <ChevronDownIcon className="h-5 w-5" aria-hidden="true" />
                        )}
                      </span>
                    </Disclosure.Button>
                  </dt>
                  <Disclosure.Panel as="dd" className="mt-2 pr-12">
                    <Typography
                      as="div"
                      size={'sm'}
                      weight="regular"
                      fontFamily={faqSection.faq_font_family}
                      color={faqSection.faq_answer_color}
                    >
                      <MarkDownRender>{faq.answer}</MarkDownRender>
                    </Typography>
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          );
        })}
      </dl>
    </div>
  );
};

export default FAQs;
